import { compose } from 'redux';
import { connect } from 'react-redux';
import * as Action from '../../../actions/EventManagement';
import ListEvents from '../../../pages/Admin/EventManagement/ListEvents';
import withAuth from '../../../common/WithAuth';

const mapStateToProps = (state) => {
    const isLoading = state.eventManagement.listEvents.isFetching
    || state.eventManagement.detailEvent.isFetching
    || state.eventManagement.createEvent.isFetching
    || state.eventManagement.editEvent.isFetching
    || state.eventManagement.deleteEvent.isFetching;

    return ({
        locale: state.locale.lang.current,
        listEvents: state.eventManagement.listEvents.data && state.eventManagement.listEvents.data.results,
        createSuccess: state.eventManagement.createEvent.success,
        editSuccess: state.eventManagement.editEvent.success,
        dataEvents: state.eventManagement.listEvents.data,
        deleteSucces: state.eventManagement.deleteEvent.success,
        deleteError: state.eventManagement.deleteEvent.errors,
        isLoading,
    });
};

const mapDispatchToProps = (dispatch) => ({
    fetchListEvents: (params) => dispatch(Action.GetListEventRequested(params)),
    fetchClearGetDetailEvent: () => dispatch(Action.ClearGetDetailEvent()),
    fetchDeleteEvent: (param) => dispatch(Action.DeleteEventRequested(param)),
    clearDetailEvent: () => dispatch(Action.ClearDeleteEvent()),
    clearListEvent: () => dispatch(Action.ClearListEvent()),
});

export default compose(
    withAuth,
    connect(
        mapStateToProps,
        mapDispatchToProps,
    ),
)(ListEvents);
